export default __webpack_public_path__ + "static/media/medkit.3a5b5645.svg";